import { ASSETS } from "./assets";

// Every item promotable to "New Drops" from the Store Manager.
// slug = stable id used by the backend `promoted_items` collection.
export const STORE_CATALOG = [
  // --- Rubs ---
  { slug: "sweet-perfection", category: "Rub", name: "Sweet Perfection", price: 12.99, size: "12.1 oz (343 g)", tag: "Best Seller",
    desc: "Our signature all-purpose seasoning. Sweet, smoky, and just enough heat. Perfect on brisket, ribs, chicken and wings.",
    img: ASSETS.productSweetPerfection },
  { slug: "silly-goose-rub", category: "Rub", name: "Silly Goose's Rub", price: 12.99, size: "12.2 oz (345 g)", tag: "Fan Favorite",
    desc: "Balanced pepper, brown sugar and paprika — built for ribs but works on damn near anything with a bone in it.",
    img: ASSETS.productSillyGoose },
  { slug: "honey-jalapeno-bliss", category: "Rub", name: "Honey Jalapeño Bliss", price: 12.99, size: "12.3 oz (348 g)", tag: "New",
    desc: "Real honey powder with jalapeño kick. Killer on chicken wings, corn on the cob and grilled shrimp.",
    img: ASSETS.productHoneyJalapeno },
  { slug: "big-moes-kickin-rub", category: "Rub", name: "Big Moe's Kickin' Rub", price: 12.99, size: "12 oz (340 g)", tag: "New",
    desc: "Bold, punchy all-purpose rub with a low-slow kick. Built for wings, ribs, brisket burnt ends, and anything that needs a wake-up call.",
    img: ASSETS.productTillmanBeefRub },

  // --- Sauces ---
  { slug: "chipotle-apple", category: "Sauce", name: "Tillman's Chipotle Apple", price: 12.99, size: "21 oz (595 g)", tag: "New",
    desc: "Smoky chipotle warmth balanced with sweet apple. Killer on pork butt, ribs, and grilled chicken thighs.",
    img: ASSETS.productChipotleAppleSauce },
  { slug: "florida-gold", category: "Sauce", name: "Tillman's Florida Gold", price: 12.99, size: "20 oz (567 g)",
    desc: "Mustard-forward gold sauce. Perfect on pulled pork & smoked chicken. Competition-grade.",
    img: ASSETS.productFloridaGoldSauce },
  { slug: "grandmas-red-sauce", category: "Sauce", name: "Tillman's Grandma's Red Sauce", price: 12.99, size: "21 oz (595 g)",
    desc: "Rich tomato-molasses classic. Small-batch, slow-reduced from a family recipe.",
    img: ASSETS.productGrandmasRedSauce },
  { slug: "last-call-sauce", category: "Sauce", name: "Last Call BBQ Sauce", price: 12.99, size: "21.5 oz (610 g)", tag: "Competition",
    desc: "Sweet & spicy — the sauce that closes out the night. Cold Beer BBQ Competition Team recipe.",
    img: ASSETS.productLastCallSauce },

  // --- Bundles ---
  { slug: "family-3-pack", category: "Bundle", name: "The Family 3-Pack (16 oz)", price: 33.00, size: "3 × 16 oz", tag: "Bundle Deal",
    desc: "Silly Goose's Rib Rub + Sweet Perfection + Honey Jalapeño Bliss. Party-size shakers. Free shipping.",
    img: ASSETS.productTrio16oz },
  { slug: "holiday-gift-pack", category: "Bundle", name: "Holiday Gift Pack", price: 45.00, size: "4 rubs · gift-ready", tag: "Holiday Special",
    desc: "All four signature rubs — Honey Jalapeño Bliss, Sweet Perfection, Big Moe's Kickin' Rub, and Silly Goose's Rib Rub. Ready to gift.",
    img: ASSETS.productHolidayGiftPack },

  // --- Apparel / Merch ---
  { slug: "florida-brisket-tee", category: "Apparel", name: "Florida Brisket Tee", price: 25.00, size: "S–3XL",
    desc: "Black cotton tee — Sunshine State plate print on the back, small When Pigs Fly logo on the front chest, Old Glory on the sleeve.",
    img: ASSETS.floridaBrisketTee },
  { slug: "rubbin-racin-tee", category: "Apparel", name: "Rubbin' & Racin' Racing Team Tee", price: 25.00, size: "S–3XL",
    desc: "Black cotton tee — When Pigs Fly Racing Team back print featuring the pig, chicken and cow on a checkered flag.",
    img: ASSETS.teeRubbinRacin },
  { slug: "neon-bbq-tee", category: "Apparel", name: "When Pigs Fly BBQ Neon Tee", price: 25.00, size: "S–3XL",
    desc: "Black cotton tee — vintage neon sign back print. When Pigs Fly BBQ in glowing red script with the flying pig cutting through the letters.",
    img: ASSETS.teeNeonBbq },
  { slug: "bbq-lifestyle-tee", category: "Apparel", name: "BBQ — It's a Lifestyle Tee", price: 25.00, size: "S–3XL",
    desc: "Black cotton tee — neon pig butcher chart back print. Faith · Family · Friends · BBQ.",
    img: ASSETS.teeBbqLifestyle },
  { slug: "team-felicia-tee", category: "Apparel", name: "We Support Team Felicia Tee", price: 25.00, size: "S–3XL",
    desc: "Natural cream cotton tee — CMT awareness ribbon with floral back print. A portion of every sale goes toward the fight against CMT.",
    img: ASSETS.teeTeamFelicia },
  { slug: "silly-goose-hat", category: "Apparel", name: "Silly Goose Club Trucker Hat", price: 35.00, size: "One size",
    desc: "Black flat-brim trucker with cream Silly Goose Club embroidery and white rope brim.",
    img: ASSETS.productSillyGooseHat },
  { slug: "wpf-cap", category: "Apparel", name: "When Pigs Fly Cap", price: 35.00, size: "One size",
    desc: "Structured black perforated cap with the When Pigs Fly Apparel Co. leather patch.",
    img: ASSETS.productCap },
];

export const CATALOG_BY_SLUG = Object.fromEntries(STORE_CATALOG.map((it) => [it.slug, it]));
